// export const FRONTEND_URL = "http://localhost:3000";
export const FRONTEND_URL = "https://sociallinkr.netlify.app";
